module.exports = __webpack_public_path__ + "static/media/Artboard9.d61ddd21.png";